define('extensions/lodash/isInteger',[
], function () {
    'use strict';

    // Return a basic object so we can call _.mixin in the main dependency injection file
    // ("mixins.js").
    return {
        /**
         * Checks if the provided value is not null and is not undefined.
         *
         * @param  {Anything}  arg The thing that will be checked if it is defined and is
         *  not null.
         *
         * @return {Boolean} True if the provided argument is not equal to null and is not
         *  equal to undefined.
         */
        isInteger: function (arg) {
            if(typeof arg === 'string') {
                arg = Number(arg);
            } else if(typeof arg !== 'number') {
                return false;
            }

            return typeof arg === "number" &&
                isFinite(arg) &&
                Math.floor(arg) === arg;
        }
    };
});

